import { render, staticRenderFns } from "./portal-approve-part.vue?vue&type=template&id=b0e0b818&scoped=true"
import script from "./portal-approve-part.vue?vue&type=script&lang=js"
export * from "./portal-approve-part.vue?vue&type=script&lang=js"
import style0 from "./portal-approve-part.vue?vue&type=style&index=0&id=b0e0b818&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e0b818",
  null
  
)

export default component.exports